module.exports = __webpack_public_path__ + "img/preview.b5bfa190.webp";